module.exports = __webpack_public_path__ + "static/media/uwai-image.984874d1.png";